var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserRequests(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_729_2515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0882 0.100106C40.4398 -1.61379 53.4321 18.7843 43.6765 35.5313L46.9405 45.5366C46.9314 47.2779 45.8282 46.9861 44.5973 46.6716C41.5932 45.9058 38.5616 44.4791 35.5438 43.6678C17.145 54.4298 -4.9692 37.464 0.988996 16.7924C3.55097 7.90837 11.8022 0.925147 21.0882 0.100106ZM12.7094 19.6003C7.6082 19.696 7.76775 27.4997 12.8461 27.4085C17.9473 27.3128 17.7877 19.5091 12.7094 19.6003ZM23.4451 19.6003C18.3439 19.696 18.5034 27.4997 23.5818 27.4085C28.683 27.3128 28.5234 19.5091 23.4451 19.6003ZM34.1853 19.6003C29.0841 19.696 29.2437 27.4997 34.3221 27.4085C39.4232 27.3128 39.2637 19.5091 34.1853 19.6003Z",
    fill: "#19147E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_729_2515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRequests);
export default __webpack_public_path__ + "static/media/user-requests.65350ffe5551b976ac86a5920587c96d.svg";
export { ForwardRef as ReactComponent };